/**
 * Decimals in the made-to-measure fields - our extension of the customizer
 * (component-customizer.js, another company's code: extended from outside,
 * never changed). Loaded by sections/main-product-pdp.liquid only, the gardin
 * and solskydd templates; every other page with the customizer is as before.
 *
 * Decided with the user 2026-10-02 (PDP plan, Fas 1b):
 * - One decimal, a millimetre: 120,5 stays, 120,55 becomes 120,5 as it is
 *   typed. Comma and period both work where the browser's number field takes
 *   them (Swedish and Finnish browsers take both).
 * - A measure between two size groups is priced as the next group up, so
 *   the shopper never pays for less than the measure. The groups are whole
 *   numbers (0-150, 151-200), and the customizer's lookup finds no group for
 *   a measure between two of them (150,5): the measure's price dropped out,
 *   and with a base price the line could be bought at that alone (150,5 cm
 *   gave 99 kr instead of 1 128 kr, 2026-09-28). Now 150,1-150,9 is priced as
 *   151-200. A measure inside a group, or outside all of them, is untouched.
 *
 * What this relies on in component-customizer.js (frozen, 2026-10-02):
 * - ProductCustomizer is a global class, and findPriceForMeasurement lives on
 *   the prototype, so the wrapper reaches old instances as well as new ones
 * - findPriceForMeasurement(measurement, groupType) uses `measurement` only to
 *   pick a group in this.sizeGroups[groupType] ({ min, max, group }), and
 *   returns 0 when it finds none
 * - its input listeners sit on document in the bubble phase, so the trim
 *   below, in the capture phase, runs first: the customizer reads the trimmed
 *   value
 * Remove the script tag and the customizer runs without it.
 */
(() => {
  if (typeof ProductCustomizer === 'undefined') return;
  const proto = ProductCustomizer.prototype;
  if (proto.findPriceForMeasurement.hastaDecimals) return;

  const originalLookup = proto.findPriceForMeasurement;
  function lookup(measurement, groupType) {
    const price = originalLookup.apply(this, arguments);
    if (price) return price;
    const groups = this.sizeGroups && this.sizeGroups[groupType];
    const value = Number(measurement);
    if (!Array.isArray(groups) || !groups.length || !Number.isFinite(value)) return price;
    // inside a group, the price is that group's, whatever it is
    if (groups.some((group) => value >= group.min && value <= group.max)) return price;
    const sorted = [...groups].sort((a, b) => a.min - b.min);
    if (value < sorted[0].min || value > sorted[sorted.length - 1].max) return price;
    // between two groups: the next one up
    const next = sorted.find((group) => group.min > value);
    return next ? originalLookup.call(this, next.min, groupType) : price;
  }
  lookup.hastaDecimals = true;
  proto.findPriceForMeasurement = lookup;

  // the customizer's measurement fields (component-customizer.js isCustomizerInput)
  const FIELD = /^(max-width|max-height|mounting-height)-/;
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !FIELD.test(input.id) || !input.closest('[data-pdp]')) return;
    // cut on the string the number field gives (always with a period), not
    // on a float, so the digits kept are exactly the ones typed
    const match = /^(-?\d*)\.(\d)\d+$/.exec(input.value);
    if (match) input.value = `${match[1]}.${match[2]}`;
  }, true);
})();
